<template>
  <v-layout wrap>
    <v-flex sm12>
      <v-layout>
        <v-select
          dense
          clearable
          :items="year"
          :label="$t('EXTSEARCH_DATEINPUT_YEAR')"
          :disabled="value"
          v-model="aDate.year"
          @change="$emit('change')"
        >
        </v-select>
      <!-- </v-flex>
      <v-flex sm2> -->
        <v-select
          dense
          clearable
          :items="month"
          :label="$t('EXTSEARCH_DATEINPUT_MONTH')"
          :disabled="!date.year"
          v-model="aDate.month"
          @change="$emit('change')"
        >
        </v-select>
      <!-- </v-flex>
      <v-flex sm2> -->
        <v-select
          dense
          clearable
          :items="day"
          :label="$t('EXTSEARCH_DATEINPUT_DAY')"
          :disabled="!date.month"
          v-model="aDate.day"
          @change="$emit('change')"
        >
        </v-select>
      <!-- </v-flex>
      <v-flex sm2> -->
        <v-select
          dense
          clearable
          :items="hour"
          :label="$t('EXTSEARCH_DATEINPUT_HOUR')"
          :disabled="!date.day"
          v-model="aDate.hour"
          @change="$emit('change')"
        >
        </v-select>
      <!-- </v-flex>
      <v-flex sm2> -->
        <v-select
          dense
          clearable
          :items="minute"
          :label="$t('EXTSEARCH_DATEINPUT_MINUTE')"
          :disabled="!date.hour"
          v-model="aDate.minute"
          @change="$emit('change')"
        >
        </v-select>
      </v-layout>
    </v-flex>
    <v-flex sm12 v-if="debug">
      {{ date }}
    </v-flex>
  </v-layout>
</template>

<script>
export default {
  name: 'YMDHI',
  props: ['value', 'date', 'datatype', 'debug'],
  data() {
    return {
    }
  },
  computed: {
    aDate() {
      return this.date
    },
    year() {
      // from 2000 to current year
      const currentYear = (new Date()).getFullYear()
      // TODO: limit number of years?
      return Array.from({length: currentYear - 2000 + 1}, (v, k) => parseInt(k + 2000, 10).pad()).reverse()
    },
    month() {
      return Array.from({length: 12}, (v, k) => parseInt(k + 1, 10).pad())
    },
    day() {
      const daysInMonth = (new Date(this.date.year, this.date.month, 0)).getDate()
      return Array.from({length: daysInMonth}, (v, k) => parseInt(k + 1, 10).pad())
    },
    hour() {
      return Array.from({length: 24}, (v, k) => parseInt(k, 10).pad())
    },
    minute() {
      return Array.from({length: 60}, (v, k) => parseInt(k, 10).pad())
    },
  },
  watch: {
  },
}
</script>

<style scoped lang="scss">
.v-text-field {
  padding-top: 0;
  margin-top: 0;
  .v-input__slot {
    background: rgba(0, 0, 0, 0.06);
  }
  &.v-input--is-disabled {
    .v-input__slot {
      background: none;
    }
  }
}
.v-input {
  // font-size: 0.8em;
}
.v-select-list {
  .v-list__tile {
    font-size: 0.8em;
    height: 26px !important;
    padding: 0 8px;
  }
}
.layout {
  .v-input__icon--clear {
    min-width: 12px;
    width: 12px;
    margin: 0 -8px;
    i {
      font-size: 1em;
    }
  }
}
</style>
